import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import * as S from './TitleSection.styles'
import useScreenSize from '../../../../hooks/useScreenSize'
import { useExperimentManager } from '../../../../services/ExperimentManager/ExperimentManager'
import { type VideoRefType } from '../HomePageVideo/HomePageVideo'
import { CDN_URL } from 'config/config'

type Props = {
  ctaProps: {
    ctaText: string
    onClick: () => void
  }
  onVisibilityChange: (visibilityRatio: number) => void
  heroVideoCldId: string
}

export default function TitleSection({
  ctaProps: { ctaText, onClick },
  onVisibilityChange,
  heroVideoCldId,
}: Props) {
  const { t } = useTranslation()
  const experimentManager = useExperimentManager()
  const isMediumScreen = useScreenSize('md')
  const videoRef = useRef<VideoRefType>(null)

  useEffect(() => {
    const intersectedElement = videoRef.current?.containerRef?.current
    if (!intersectedElement) {
      return
    }

    const observer = new IntersectionObserver(
      ([e]) => {
        onVisibilityChange(e.intersectionRatio)
      },
      { threshold: [0, 0.5, 1] }
    )

    observer.observe(intersectedElement)
    return () => observer.unobserve(intersectedElement)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videoRef])

  return (
    <S.Video
      cldId={heroVideoCldId}
      cldWidth={isMediumScreen ? 2000 : undefined}
      name="Header"
      type="Video"
      preload="auto"
      autoPlay
      ref={videoRef}
    >
      <S.TitleWrapper>
        <S.TitleText>{t('homepage.title')}</S.TitleText>
        {isMediumScreen && (
          <S.Cta data-testid="cta-homepage-lets-go" onClick={onClick}>
            {ctaText}
          </S.Cta>
        )}
        {experimentManager.isEnabled('christmas') && !isMediumScreen && (
          <S.ChristmasImage
            data-testid="ChristmasImg"
            src={`${CDN_URL}/seasonal/MobileChristmas.webp`}
          />
        )}
      </S.TitleWrapper>
    </S.Video>
  )
}
